import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Species from './Species/Species';

export const MultiSpecies = () => {
    const { species, isLoading } = useSelector((state) => state.species);

    if (!species.length && !isLoading) {
        return <div className="atlas-empty-state">No species matched that search. Try a broader taxon name.</div>;
    }

    return (
        isLoading ? (
            <div className="atlas-loading-state">
                <CircularProgress />
            </div>
        ) : (
            <Grid container alignItems="stretch" spacing={3}>
                {species.map((item) => (
                    <Grid key={item._id || item.item_type_id || item.taxonKey || item.species} item xs={12} sm={6}>
                        <Species speciesInfo={item} />
                    </Grid>
                ))}
            </Grid>
        )
    )
}
